import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import {
  AddScientificCommittee,
  GetScientificCommitteeInfoRowByUserId,
} from "../../../Redux/Reducers/Manager/ScientificCommittee";
import { GetAllRoundActive } from "../../../Redux/Reducers/Manager/Dropdowns/GetAllRoundActive";
import { GetAllFieldsManager } from "../../../Redux/Reducers/Manager/Dropdowns/GetAllFieldsManager";
import { GetAllSubjectManager } from "../../../Redux/Reducers/Manager/Dropdowns/GetAllSubjectManager";
import { setRefreshTable } from "../../../Redux/Reducers/Shared/VariousVariables";
import SharedDiv from "../../../Components/SharedDiv/SharedDiv";
import InputAHSF from "../../../Components/InputAHSF";
import AllDropDownsAHSF from "../../../Components/AllDropDownsAHSF";
import TextAreaAHSF from "../../../Components/TextAreaAHSF";
import ScientificCommitteeTable from "./ScientificCommitteeTable";
import ButtonAHSF from "../../../Components/ButtonAHSF";

const SetScientificCommitteeForm = () => {
  const dispatch = useDispatch();
  const { userId } = useParams();

  const [DropDownRoundActive, setDropDownRoundActive] = useState(null);
  const [DropDownFields, setDropDownFields] = useState(null);
  const [DropDownSubject, setDropDownSubject] = useState(null);
  const [Note, setNote] = useState("");

  const ScientificCommitteeInfoRow = useSelector(
    (state) => state.ScientificCommittee?.ScientificCommitteeInfoRow
  );

  const { AllRoundActive, AllFieldsManager, AllSubjectManager } = useSelector(
    (state) => ({
      AllRoundActive: state.AllRoundActive.AllRoundActive,
      AllFieldsManager: state.AllFieldsManager.AllFieldsManager,
      AllSubjectManager: state.AllSubjectManager.AllSubjectManager,
    })
  );

  useEffect(() => {
    if (userId) {
      dispatch(GetScientificCommitteeInfoRowByUserId({ uS_UserGuid: userId }));
    }
  }, [userId, dispatch]);

  useEffect(() => {
    dispatch(GetAllRoundActive());
  }, [dispatch]);

  useEffect(() => {
    if (DropDownRoundActive) {
      dispatch(
        GetAllFieldsManager({ roundYearId: parseInt(DropDownRoundActive) })
      );
    }
  }, [DropDownRoundActive, dispatch]);

  useEffect(() => {
    if (DropDownFields) {
      dispatch(GetAllSubjectManager({ fieldId: DropDownFields }));
    }
  }, [DropDownFields, dispatch]);

  const handleAddScientificCommittee = async () => {
    const missingFields = [];

    if (!DropDownRoundActive) missingFields.push("الدورة");
    if (!DropDownFields) missingFields.push("الحقل");
    if (!DropDownSubject) missingFields.push("الموضوع");

    if (missingFields.length > 0) {
      Swal.fire({
        icon: "warning",
        title: "الرجاء تعبئة الحقول التالية",
        html: `
          <div style="text-align: right; direction: rtl; font-size: 16px;">
            <ul style="list-style-type: none; padding: 0;">
              ${missingFields
                .map(
                  (field) =>
                    `<li style="margin-bottom: 8px;">🔸 <strong>${field}</strong></li>`
                )
                .join("")}
            </ul>
          </div>
        `,
        confirmButtonText: "حسناً",
        customClass: {
          popup: "swal2-border-radius",
        },
      });
      return;
    }

    try {
      const result = await dispatch(
        AddScientificCommittee({
          userId: ScientificCommitteeInfoRow?.userGuid,
          fieldId: DropDownFields,
          roundId: DropDownRoundActive,
          subjectId: DropDownSubject,
          note: Note,
        })
      ).unwrap();

      if (result.message === "لا يمكن تكرار نفس الحقل و الموضوع لنفس الدورة") {
        Swal.fire({
          icon: "error",
          title: "تنبيه",
          text: result.message,
          confirmButtonText: "حسناً",
        });
      } else {
        Swal.fire({
          icon: "success",
          title: "تمت الإضافة بنجاح",
          showConfirmButton: false,
          timer: 1500,
        });

        // ✅ Refresh table after success
        dispatch(setRefreshTable({ tableId: "ScientificCommittee" }));
        setDropDownRoundActive(null);
        setDropDownFields(null);
        setDropDownSubject(null);
        setNote("");
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "خطأ",
        text: error?.message || "حدث خطأ غير متوقع",
        confirmButtonText: "حسناً",
      });
    }
  };

  return (
    <>
      {ScientificCommitteeInfoRow ? (
        <SharedDiv
          showTitle={true}
          titleNameAR="معلومات عضو اللجنة العلمية"
          child={[
            <div className="containerSetEvaluterForm" key="form">
              <div className="containerSetEvaluterFormChild">
                <div className="form-grid">
                  <InputAHSF
                    fieldsName="ScientificCommitteeName"
                    show={true}
                    disabled={true}
                    defaultValue={
                      ScientificCommitteeInfoRow?.scientificCommitteeName
                    }
                  />

                  <InputAHSF
                    fieldsName="EvaluatorEmail"
                    show={true}
                    disabled={true}
                    defaultValue={ScientificCommitteeInfoRow?.email}
                  />

                  <AllDropDownsAHSF
                    fieldsName="Round"
                    show={true}
                    id="round"
                    lang="ar"
                    arrayOoptionList={AllRoundActive}
                    KeyText={"roundNameAr"}
                    KeyValue={"roundYearId"}
                    dropdownType={"normal"}
                    onChange={(e) => {
                      setDropDownRoundActive(e.target.value);
                    }}
                    defaultValue={DropDownRoundActive}
                  />

                  <AllDropDownsAHSF
                    fieldsName="field"
                    lang="ar"
                    show={true}
                    arrayOoptionList={AllFieldsManager}
                    KeyText={"fieldNameAr"}
                    KeyValue={"fieldId"}
                    dropdownType={"normal"}
                    onChange={(e) => {
                      setDropDownFields(e.target.value);
                    }}
                    defaultValue={DropDownFields}
                  />

                  <AllDropDownsAHSF
                    fieldsName="topic"
                    lang="ar"
                    show={true}
                    arrayOoptionList={AllSubjectManager}
                    KeyText={"subjectNameAr"}
                    KeyValue={"subjectId"}
                    dropdownType={"normal"}
                    onChange={(e) => {
                      setDropDownSubject(e.target.value);
                    }}
                    defaultValue={DropDownSubject}
                  />

                  <TextAreaAHSF
                    fieldsName="Note"
                    show={true}
                    onChange={(e) => {
                      setNote(e.target.value);
                    }}
                    // defaultValue={Note}
                    value={Note}
                  />
                </div>
              </div>
            </div>,

            <ScientificCommitteeTable key="table" />,
            <div className="containerButtonMAin" key="btn">
              <ButtonAHSF
                onClick={handleAddScientificCommittee}
                fieldsName="Assign"
                lang={"ar"}
                title={"تعيين"}
                text={"تعيين"}
                show={true}
              />
            </div>,
          ]}
        />
      ) : null}
    </>
  );
};

export default SetScientificCommitteeForm;
